import React, { Component } from "react";
import { connect } from "react-redux";
import CustomizableTable from "./CustomizableTable";

import { setCheckbox } from "../../actions/multiselectActions";
import { RowCheckbox } from "../RowCheckbox";
import {
	selectTableRootMap,
	selectTableTypeMap,
} from "../../reducers/multiselectReducer";

const prependCheckbox = (data) =>
	data.map((item) => ({ ...item, selected: false }));

const clickableCellStyle = {
	cursor: "pointer",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	margin: "-5px -10px",
	padding: "5px 10px",
	height: "calc(100% + 10px)",
};

class SelectTable extends Component {
	constructor(props, context) {
		super(props, context);

		this.addColumnHeader = this.addColumnHeader.bind(this);
		this.checkboxClicked = this.checkboxClicked.bind(this);
	}
	checkboxClicked(e, id, type, row) {
		this.props.setCheckbox(
			selectTableRootMap[this.props.root],
			id,
			e.currentTarget.checked,
			type,
			row.original
		);
	}
	addColumnHeader(columns) {
		return [
			{
				Header: (
					<div
						style={clickableCellStyle}
						onClick={this.props.headerBoxClicked}
					>
						<RowCheckbox
							checked={this.props.headerChecked}
							onChange={() => {}}
							style={{ pointerEvents: "none" }}
						/>
					</div>
				),
				width: 40,
				accessor: "selected",
				sortable: false,
				resizable: false,
				filterable: false,
				unhidable: true,
				Cell: (row) => {
					const isChecked =
						this.props.selectedItems[
							selectTableTypeMap[row.original.type]
						] &&
						this.props.selectedItems[
							selectTableTypeMap[row.original.type]
						][row.original.id]
							? true
							: false;
					return (
						<div
							style={clickableCellStyle}
							onClick={() => {
								const syntheticEvent = {
									currentTarget: { checked: !isChecked },
								};
								this.checkboxClicked(
									syntheticEvent,
									row.original.id,
									row.original.type,
									row
								);
							}}
						>
							<RowCheckbox
								checked={isChecked}
								onChange={() => {}}
								style={{ pointerEvents: "none" }}
							/>
						</div>
					);
				},
			},
		].concat(columns);
	}
	render() {
		return (
			<CustomizableTable
				{...this.props}
				data={prependCheckbox(this.props.data)}
				columns={this.addColumnHeader(this.props.columns)}
			/>
		);
	}
}
const mapStateToProps = (state, ownProps) => {
	return {
		selectedItems: state.multiselect[selectTableRootMap[ownProps.root]],
		headerChecked:
			state.multiselect[selectTableRootMap[ownProps.root]].header,
	};
};
export default connect(mapStateToProps, { setCheckbox })(SelectTable);
